import { render, staticRenderFns } from "./getInTouch.vue?vue&type=template&id=623b3710"
import script from "./getInTouch.vue?vue&type=script&lang=js"
export * from "./getInTouch.vue?vue&type=script&lang=js"
import style0 from "./getInTouch.vue?vue&type=style&index=0&id=623b3710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports